import React from "react";
import "./InfoRestaurantHome.css";
import Body3 from "../Text/Body3";
import Subtitle2 from "../Text/Subtitle2";
import { isMobile } from "react-device-detect";
import { Flex, Typography, Image } from "antd";

export default function InfoRestaurantHome() {

    const restaurant = JSON.parse(localStorage.getItem("userData"));

    return (
        isMobile ?
            <Flex gap={20} style={{
                width: "100%",
                height: "100%",
            }}>
                <Flex style={{
                    width: "20%",
                    height: "100%",
                }}>
                    <Image src={restaurant.img} type="image/png" alt="line" style={{
                        width: "100%",
                        height: "100%",
                    }} />
                </Flex>
                <Flex vertical style={{ width: "80%" }}>
                    <Typography.Title level={5}>
                        {restaurant.name}
                        <br />
                        Endereço:
                        {restaurant.address}
                        <br />
                        Tel: 
                        {restaurant.contact}
                    </Typography.Title>
                </Flex>
            </Flex>
            :
            <div className="restaurant-info-div">
                <div className="restaurant-info-first-div">
                    <img src={restaurant.img} type="image/png" alt="line" style={{ height: 100, width: 100 }} />
                </div >
                <div className="restaurant-info-secound-div">
                    <Subtitle2 text={restaurant.name} />
                    <div>
                        <Subtitle2 text="Endereço: " />
                        <Body3 text={restaurant.address} />
                    </div>
                    <div>
                        <Subtitle2 text="Contato: " />
                        <Body3 text={restaurant.contact} />
                    </div>
                </div>
            </div >

    )
}